import type { EntityType } from '@tunasong/schemas'
import type { AgentDefinition } from '../plugin-types.js'
import { usePlugins } from './editor-plugins.js'

/** Collect all AgentDefinitions from active plugins, optionally filtered by entity type. */
export const useAgentDefinitions = (entityType?: EntityType): AgentDefinition[] => {
  const plugins = usePlugins('all')
  const all = (plugins ?? []).flatMap(p => (p.getAgentDefinitions ? p.getAgentDefinitions() : []))
  if (!entityType) {
    return all
  }
  return all.filter(d => d.entityTypes.includes(entityType))
}
